import React, { useState } from 'react'
import axios from 'axios'
import mixpanel from '../../utilities/mixpanel'

import SEOHead from '../utilities/SEOHead'
import { extractErrorMessage } from '../../utilities/errorHelpers'
import ForgotPasswordModal from '../leevo_ui/ForgotPasswordModal/ForgotPasswordModal'

export default function ForgotPasswordFeature() {
  const [successMessage, setSuccessMessage] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  function onForgotPasswordSubmit({ email }) {
    setSuccessMessage('')
    setErrorMessage('')
    return axios
      .post('/auth/password', {
        email,
        redirect_url: `${window.location.origin}/password/new`
      })
      .then(({ data }) => {
        mixpanel.track('Password Reset Initiated')
        setSuccessMessage(data.message)
      })
      .catch((error) => {
        mixpanel.track('Password Reset Initiation Failed')
        setErrorMessage(extractErrorMessage(error))
      })
  }

  return (
    <>
      <SEOHead
        title="Forgot Password"
        description="Reset your Leevo password. Enter your email address to receive password reset instructions."
        path="/forgot_password"
        noindex={true}
      />
      <ForgotPasswordModal
        errorMessage={errorMessage}
        onForgotPasswordSubmit={onForgotPasswordSubmit}
        successMessage={successMessage}
      />
    </>
  )
}
